'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _themeSections = require('@shopify/theme-sections');

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _themeSections.register)('featured-reviews', {
	onLoad: function onLoad() {
		var _this2 = this;

		return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
			var app_key, _this;

			return _regenerator2.default.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							app_key = $('.featured-reviews').data('app-key');
							_this = _this2;


							$.ajax({
								url: "https://api.yotpo.com/v1/widget/" + app_key + "/products/yotpo_site_reviews/reviews.json?per_page=5&page=1" }).done(function (data) {
								if ($('.featured-reviews').length) {
									var reviews = data.response.reviews;
									for (var i in reviews) {
										var date = new Date(reviews[i].created_at);
										var review_html = '<div class="swiper-slide"><div class="review"><div class="review__title">' + reviews[i].title + '</div><div class="review__content">' + reviews[i].content + '</div><div class="review__author"><span>' + reviews[i].user.display_name + ', </span>' + date.getFullYear() + '</div></div></div>';
										$('.featured-reviews').find('.swiper-wrapper').append(review_html);
									}
									_this.sliders();
								}
							});

							$(window).on("resize orientationchange", function () {
								app.reviewsSwiper.destroy();
								_this.sliders();
							});

						case 4:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this2);
		}))();
	},
	sliders: function sliders() {
		app.reviewsSwiper = new _swiper2.default('.swiper-reviews', {
			loop: true,
			slidesPerView: 3,
			allowTouchMove: false,
			spaceBetween: 32,
			breakpoints: {
				480: {
					slidesPerView: 1,
					autoHeight: true,
					allowTouchMove: true,
					pagination: {
						el: '.swiper-pagination',
						type: 'bullets',
						clickable: 'true'
					}
				},
				767: {
					slidesPerView: 2,
					autoHeight: true,
					allowTouchMove: true,
					pagination: {
						el: '.swiper-pagination',
						type: 'bullets',
						clickable: 'true'
					}
				}
			}
		});
	}
});